
<div id="hotkeys">
    <b-row style="height: 85vh !important; overflow-y: auto">
        <b-col cols="4">
            <b-list-group-item
                class="list-group col-lg-12"
                v-for="(hotkey, index) in functionkeys"
                :key="index"
            >
                <kbd>{{ hotkey.whichKey }}</kbd>
                &nbsp;&nbsp;<span v-html="hotkey.command" />
            </b-list-group-item>
        </b-col>
        <b-col cols="7">
            <b-list-group-item
                class="list-group col-lg-12"
                v-for="(hotkey, index) in hotkeys"
                :key="index"
            >
                <kbd>{{ hotkey.whichKey }}</kbd>
                {{ hotkey.command }}
            </b-list-group-item>
        </b-col>
    </b-row>
</div>
